import React from "react";
import { Check } from "lucide-react";
import {
  StepVisualState,
  WIZARD_STEPS,
} from "./serviceWizardValidation";
import "./styles/VerticalStepper.css";

type Props = {
  currentStep: number;
  stepStates: Record<number, StepVisualState>;
  onStepClick?: (step: number) => void;
};

const VerticalStepper: React.FC<Props> = ({
  currentStep,
  stepStates,
  onStepClick,
}) => {
  const handleClick = (stepId: number, state: StepVisualState) => {
    if (!onStepClick) return;
    if (state === "pending") return;
    if (stepId <= currentStep || state === "completed") {
      onStepClick(stepId);
    }
  };

  return (
    <nav className="svc-wizard-stepper" aria-label="Progreso del formulario">
      <ol className="svc-wizard-stepper__list">
        {WIZARD_STEPS.map((step, index) => {
          const state = stepStates[step.id] ?? "pending";
          const isLast = index === WIZARD_STEPS.length - 1;
          const isClickable =
            Boolean(onStepClick) &&
            state !== "pending" &&
            (step.id <= currentStep || state === "completed");

          return (
            <li key={step.id} className="svc-wizard-stepper__item">
              <button
                type="button"
                className={`svc-wizard-stepper__node svc-wizard-stepper__node--${state}${
                  isClickable ? " svc-wizard-stepper__node--clickable" : ""
                }`}
                onClick={() => handleClick(step.id, state)}
                disabled={!isClickable}
                aria-current={step.id === currentStep ? "step" : undefined}
              >
                <span className="svc-wizard-stepper__circle" aria-hidden>
                  {state === "completed" ? (
                    <Check size={20} strokeWidth={2.5} />
                  ) : (
                    <span className="svc-wizard-stepper__number">{step.id}</span>
                  )}
                </span>
                <span className="svc-wizard-stepper__text">
                  <span className="svc-wizard-stepper__short">{step.shortLabel}</span>
                  <span className="svc-wizard-stepper__label">{step.label}</span>
                </span>
              </button>
              {!isLast && (
                <span
                  className={`svc-wizard-stepper__line svc-wizard-stepper__line--${
                    state === "completed" ? "completed" : state === "error" ? "error" : "default"
                  }`}
                  aria-hidden
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default VerticalStepper;
